import React, { Component } from 'react';
import handleViewport from 'react-in-viewport';
import {cleanPath} from '../../Utils.js';
import {Link} from "react-router-dom";

import './Projectcard.scss';

const SIZES = [
  'projectcard--medium',
  'projectcard--large',
  'projectcard--small'
]

class ProjectcardSection extends Component {

  constructor(props) {
    super(props);


    const inviewOpts = {threshold: 0};
    //const [inView] = useState();

    this.state = { loaded: false, hover : false, inView: false};

    this.card = React.createRef();

    this._handleMouseEnter = this.handleMouseEnter.bind(this);
    this._handleMouseLeave = this.handleMouseLeave.bind(this);
    this._handleMouseLeave = this.handleMouseLeave.bind(this);
    this._handleOnClick = this.handleOnClick.bind(this);

  }

  componentDidMount() {

  }

  handleOnClick() {

  }

   handleImageLoaded() {
    this.setState({ loaded: true });
  }

   handleMouseEnter() {
     this.setState({ hover: true });
     if (this.props.cinema) {
       document.body.classList.add('body--cinema');
     }
   }

   handleMouseLeave() {
     this.setState({ hover: false });
     if (this.props.cinema) {
       document.body.classList.remove('body--cinema');
    }
  }

  isInview() {
     const { inViewport, enterCount } = this.props;

     let inview = true;

     //Fade in only the first time we enter the viewport
     if (inViewport && enterCount === 1) {
       inview = true;
     } else if (!inViewport && enterCount < 1) {
       inview = false;
     }

     return inview;

  }


  render() {
    const { enterCount, leaveCount } = this.props;

    const size = this.props.size;
    const index = this.props.index;
    const checkSizes = SIZES.includes(this.props.size) ? size : SIZES[0];
    const url = cleanPath(this.props.url);
    const loadedClass = (this.state.loaded) ? 'loaded' : '';
    const hoverClass = (this.state.hover) ? 'hover' : '';

    let inviewClass = (this.isInview()) ? 'inview' : '';

    return (
      <article className={`projectcard ${checkSizes} ${loadedClass} ${hoverClass} ${inviewClass}`} ref={this.card}>
        <Link to={url} className="projectcard__inner" href={url} onClick={this.props.onClick} onMouseEnter={this._handleMouseEnter} onMouseLeave={this._handleMouseLeave}>
          <div className="projectcard__media">
            <div className="projectcard__media__inner">
              <img src={this.props.featuredimage} alt={this.props.title} onLoad={this.handleImageLoaded.bind(this)} />
              {this.state.hover && this.props.featuredimageanimated &&
                <img src={this.props.featuredimageanimated} alt="" />
              }
            </div>
          </div>
          <div className="projectcard__body">
            {index &&
              <div className="projectcard__index">{index}</div>
            }
            <h2 className="projectcard__title">
              <span dangerouslySetInnerHTML={{__html: this.props.title}} />
            </h2>
          </div>
        </Link>
      </article>
    )
  }
}

const Projectcard = handleViewport(ProjectcardSection, { rootMargin: '-1.0px' });

export default Projectcard;
